import { createViewConfig } from '@sail/engine';
export const SelectFieldConfig = createViewConfig({
    name: 'SelectField',
    props: {},
    defaults: {
        defaultExpandedKeys: 'all',
        expandable: false,
        selectionMode: 'single',
        size: 'medium',
        selectionAllEnabled: true,
        clearable: false
    }
});

//# sourceMappingURL=SelectFieldConfig.js.map